import enums from '@/utils/enum'
import Notification from '@/utils/notification/Notification'

export default class Message extends Notification {
  constructor(msg, args = {}) {
    super(args)
    this.msg = $t(msg)
    this.type = enums.notification.types.MESSAGE
    this.severity = enums.notification.severity.INFO
  }
}
